<div class="cc" role="timer" aria-live="off" [attr.aria-label]="remaining + ' left to order. It ships ' + shipDay + '.'">
  <p class="cc-live"><span class="cc-dot" aria-hidden="true"></span>Live · Brooklyn stockroom</p>
  <p class="cc-time">{{ remaining }}</p>
  <p class="cc-note">left to order. <strong>It ships {{ shipDay }}.</strong></p>

  <div class="cc-track" aria-hidden="true" [style.--p]="progress">
    <span class="cc-cutoff-label">2 PM cut-off</span>
    <span class="cc-line"></span>
    <span class="cc-fill"></span>
    <span class="cc-tick cc-tick--cutoff"></span>
    <span class="cc-tick cc-tick--end"></span>
    <span class="cc-knob"><img src="/images/svg/home/hero-truck.svg" alt="" width="11" height="11" /></span>
  </div>
  <div class="cc-scale" aria-hidden="true">
    <span>7 AM</span>
    <span>Same-day run</span>
  </div>
</div>
